/**
 * Badge — token-driven status pill. Pass a `tone` mapping to one of the
 * semantic color groups defined in App.css. Never hardcode colors.
 */
const TONES = {
  primary: { bg: "var(--color-primary-tint)", border: "var(--color-border)",          color: "var(--color-primary)" },
  neutral: { bg: "var(--color-surface-alt)",  border: "var(--color-border)",          color: "var(--color-text-muted)" },
  success: { bg: "var(--color-success-bg)",   border: "var(--color-success-border)",  color: "var(--color-success)" },
  info:    { bg: "var(--color-info-bg)",       border: "var(--color-info-border)",     color: "var(--color-info)" },
  warning: { bg: "var(--color-warning-bg)",    border: "var(--color-warning-border)",  color: "var(--color-warning)" },
  high:    { bg: "var(--color-high-bg)",        border: "var(--color-high-border)",     color: "var(--color-high)" },
  danger:  { bg: "var(--color-danger-bg)",      border: "var(--color-danger-border)",   color: "var(--color-danger)" },
};

export default function Badge({ tone = "neutral", dot = false, children, className = "" }) {
  const t = TONES[tone] ?? TONES.neutral;
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full border whitespace-nowrap ${className}`}
      style={{ background: t.bg, borderColor: t.border, color: t.color }}
    >
      {dot && <span className="w-1.5 h-1.5 rounded-full" style={{ background: t.color }} />}
      {children}
    </span>
  );
}

export { TONES };
